import { requests } from './baseServices'

export const RateServices = {    
    getAll: (criteria) => requests.get('api/rates', criteria),
    getAllWithOptions: (criteria) => requests.post('api/rates/filtered', criteria),
    getById: (id) => requests.get(`api/rates/${id}`),
    update: (id, template) => requests.put(`api/rates/${id}`, template),
    create: (template) => requests.post(`api/rates`, template),    
    delete: (id) => requests.delete(`api/rates/${id}`),    
    upload: (formData) => requests.post('api/rates/upload', formData),
};